/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const r = (o) => {
  var t;
  return {
    enabled: typeof o == "boolean" ? o : (t = o == null ? void 0 : o.enabled) != null ? t : !0,
    column: typeof o == "boolean" || o == null ? void 0 : o.column
  };
};
export {
  r as getDetailExpandableOptions
};
